export enum PerformanceLoaderKey {
  GET_METRICS = 'performance-get-metrics',
  GET_METRIC_HISTORY = 'performance-get-metric-history',
}

export enum PerformanceTimePeriod {
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
}

export enum PerformanceStatus {
  IMPROVING = 'improving',
  STABLE = 'stable',
  DECLINING = 'declining',
}

export enum MetricType {
  DAYS = 'days',
  PERCENTAGE = '%',
  COUNT = 'count',
}
